// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import moment from "moment";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Input,
  SelectInput,
  RenderInputFields,
  SubmitButton,
} from "../Form/Form";
import { API } from "../../constant/api";

const titleSingular = "Offer";

const Edit = (props) => {
  const { id } = props.match.params;
  const history = useHistory();
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const [isOtherBrand, setIsOtherBrand] = useState(false);
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const [isProfilePicRemove1, setIsProfilePicRemove1] = useState(false);
  const imgArray = ["image/png", "image/jpeg", "image/jpg"];

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch,
  } = useForm();

  // Request handler
  const { response, request } = useRequest();
  const { request: requestBrands, response: responseBrands } = useRequest();
  const { response: responseFetchUser, request: requestFetchSeeker } =
    useRequest();

  useEffect(() => {
    requestBrands("GET", "brand");
  }, []);




  useEffect(() => {
    if (id) {
      requestFetchSeeker("GET", `offer/get/${id}`);
      document.title = `Edit ${titleSingular} - Easyspare`;
    }
  }, [id]);

  useEffect(() => {
    if (responseFetchUser) {
      const {
        brand,
        image,
        code,
        description,
        discountAmount,
        type,
        offerStartDate,
        offerEndDate,
      } = responseFetchUser.offer;
      if (image) {
        setImage(`${API.PORT}/${image}`);
      }

      if (brand?.image) {
        setImage1(`${API.PORT}/${brand.image}`);
      }

      if (responseBrands?.data) {
        const brandOption = responseBrands.data.find(
          (item) => item._id === brand?._id
        );
        setIsOtherBrand(brandOption ? false : true);
        setValue("brands", brandOption ? brandOption._id : "other");
      }
      setValue("otherBrandName", brand?.name ?? "");

      setValue("code", code);
      setValue("description", description);
      setValue("discountAmount", discountAmount);
      setValue("type", type);
      offerStartDate &&
        setValue("offerStartDate", moment(offerStartDate).format("YYYY-MM-DD"));
      offerEndDate &&
        setValue("offerEndDate", moment(offerEndDate).format("YYYY-MM-DD"));
    }
  }, [responseFetchUser, responseBrands]);

  useEffect(() => {
    if (response) {
      toast.success(response.message);
      history.push("/offers");
    }
  }, [response]);

  const displayImageHandler = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
    setIsProfilePicRemove(false);
  };

  const handleRemoveMedia = () => {
    setIsProfilePicRemove(true);
    setValue("profilePic", "");
    setImage("");
  };

  const handleRemoveMedia1 = () => {
    setIsProfilePicRemove1(true);
    setValue("brandPic", "");
    setImage1("");
  };

  const displayImageHandler1 = (e) => {
    setImage1(URL.createObjectURL(e.target.files[0]));
    setIsProfilePicRemove1(false);
  };

  const onSubmit = (data) => {
    let {
      type,
      brands,
      code,
      description,
      profilePic,
      otherBrandName,
      brandPic,
      discountAmount,
      offerStartDate,
      offerEndDate,
    } = data;

    const formData = new FormData();
    formData.append("type", type);
    offerStartDate && formData.append("offerStartDate", offerStartDate);
    offerEndDate && formData.append("offerEndDate", offerEndDate);
    formData.append("brand", brands);
    formData.append("code", code);
    formData.append("description", description);
    formData.append("discountAmount", discountAmount);
    formData.append("isProfilePicRemove", isProfilePicRemove);
    formData.append("isProfilePicRemove1", isProfilePicRemove1);

    if (isOtherBrand) {
      formData.append("brandName", otherBrandName);
      if (brandPic && brandPic[0]) {
        const profilePicType = brandPic[0].type;
        if (!imgArray.includes(profilePicType)) {
          toast.error("Please select image only in Brand Image");
          return;
        } else {
          formData.append("brand-images", brandPic[0]);
        }
      }
    }

    if (profilePic && profilePic[0]) {
      const profilePicType = profilePic[0].type;
      if (!imgArray.includes(profilePicType)) {
        toast.error("Please select an image only in Offer Image");
        return;
      } else {
        formData.append("offer-image", profilePic[0]);
      }
    }

    request("PUT", `offer/update/${id}`, formData);
  };

  console.log(isOtherBrand,'isOtherBrandisOtherBrand')
  const InputFields = [
    [
      {
        Component: SelectInput,
        label: "Type",
        name: "type",
        registerFields: {
          required: true,
        },
        children: (
          <>
            <option value="">Select</option>
            <option value="flat">Flat</option>
            <option value="percentage">Percentage</option>
          </>
        ),
      },
      {
        Component: Input,
        label: "Code",
        type: "text",
        name: "code",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Input,
        label: "Discount Amount",
        type: "number",
        name: "discountAmount",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Input,
        label: "Description",
        type: "text",
        name: "description",
        registerFields: {
          required: false,
        },
      },
      {
        Component: SelectInput,
        label: "Brand Name",
        name: "brands",
        onChange: (value) => {
          console.log(value,'valuevalue')
          setIsOtherBrand(value == "other");
        },
        registerFields: {
          required: true,
        },
        children: (
          <>
            <option value="">Select</option>
            <option value="other">Other</option>
            {responseBrands?.data?.length &&
              responseBrands?.data?.map((item) => {
                return (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                );
              })}
          </>
        ),
      },

      {
        Component: Input,
        label: "Other Brand Name",
        type: "text",
        name: "otherBrandName",
        registerFields: {
          required: true,
        },
        isShow: isOtherBrand,
        control,
      },

      {
        Component: Input,
        label: "Brand Image",
        type: "file",
        name: "brandPic",
        registerFields: {
          required: false,
          // setValueAs: (a) => a.trim(),
        },
        registerFieldsFeedback: {
          // pattern: "The zip code field must be a valid zip code.",
        },
        isShow: isOtherBrand,
        handleMedia: displayImageHandler1,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image1 && (
          <>
            <img
              src={image1}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia1} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },

      {
        Component: Input,
        label: "Offer Image",
        type: "file",
        name: "profilePic",
        note: " 800px X 300px ",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        handleMedia: displayImageHandler,
        isMedia: true,
        accept: ".png, .jpg, .jpeg",
        control,
        children: image && (
          <>
            <img
              src={image}
              width={150}
              height={100}
              alt=""
              style={{ cursor: "pointer", marginBottom: "10px" }}
              data-fancybox
            />
            <Link to="#" onClick={handleRemoveMedia} className="mx-3">
              Remove
            </Link>
          </>
        ),
      },
      {
        Component: Input,
        label: "Offer Start Date",
        type: "date",
        name: "offerStartDate",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        inputData: {
          min: moment().format("YYYY-MM-DD"),
        },
      },
      {
        Component: Input,
        label: "Offer End Date",
        type: "date",
        name: "offerEndDate",
        registerFields: {
          required: false,
          setValueAs: (v) => v.trim(),
        },
        inputData: {
          min: moment().format("YYYY-MM-DD"),
        },
      },
    ],
  ];

  return (
    <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
      <Breadcrumb
        title="Edit Offer"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: { pathname: "/offers" },
            name: "Back To Offers",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Edit Offer</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <RenderInputFields
                      InputFields={InputFields}
                      errors={errors}
                      register={register}
                    />
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
